var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeneficios2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #feecb0;\n      }\n\n      .cls-2 {\n        fill: #414141;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M152.73,105.08v56.87c0,9.78-7.95,17.73-17.73,17.73H53.53c-9.78,0-17.74-7.95-17.74-17.73v-56.87c0-9.77,7.96-17.73,17.74-17.73h9.92v-24.75c0-16.99,13.82-30.81,30.81-30.81,8.23,0,15.97,3.2,21.79,9.01,5.83,5.84,9.03,13.58,9.03,21.8v24.75h9.92c9.78,0,17.73,7.96,17.73,17.73Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M140.74,173.95H59.26c-9.78,0-17.73-7.95-17.73-17.73v-56.87c0-9.78,7.95-17.73,17.73-17.73h81.47c9.78,0,17.73,7.95,17.73,17.73v56.87c0,9.78-7.95,17.73-17.73,17.73ZM59.26,88.38c-6.05,0-10.96,4.92-10.96,10.96v56.87c0,6.05,4.92,10.96,10.96,10.96h81.47c6.05,0,10.96-4.92,10.96-10.96v-56.87c0-6.05-4.92-10.96-10.96-10.96H59.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.82,85.01h-6.77v-28.14c0-6.42-2.5-12.46-7.04-17.01-4.54-4.54-10.59-7.04-17-7.04-13.26,0-24.05,10.79-24.05,24.05v28.14h-6.77v-28.14c0-16.99,13.82-30.81,30.81-30.81,8.22,0,15.96,3.2,21.79,9.02,5.82,5.83,9.02,13.57,9.02,21.79v28.14Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.15,118.2c0-6.16-4.99-11.15-11.15-11.15s-11.15,4.99-11.15,11.15c0,4.04,2.16,7.57,5.37,9.52v15.02c0,3.19,2.59,5.78,5.78,5.78s5.78-2.59,5.78-5.78v-15.02c3.22-1.96,5.37-5.48,5.37-9.52Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeneficios2);
export default __webpack_public_path__ + "static/media/beneficios2.d57fe83f8c97d9fe74217673519a14ae.svg";
export { ForwardRef as ReactComponent };